// BBD-138: the comments section of a document is docked to the bottom of the
// document's scroll area (position: sticky, see Comments.css) so it is always
// in reach, however long the document is. This module holds what the personal
// and workspace comment components share: the open/collapsed state, remembered
// per browser, and the header bar that toggles it.
import React, { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "bb.commentsDockOpen";

function readStoredState() {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
        return false;
    }
}

export function useCommentsDock() {
    const [isOpen, setIsOpen] = useState(readStoredState);

    useEffect(() => {
        try {
            window.localStorage.setItem(STORAGE_KEY, isOpen ? "1" : "0");
        } catch (e) {
            // Blocked storage: the dock still works, it just forgets the choice.
        }
    }, [isOpen]);

    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
    const open = useCallback(() => setIsOpen(true), []);

    return { isOpen, toggle, open };
}

export function CommentsDockHeader({ count, isOpen, onToggle, onAdd, bodyId }) {
    const handleAdd = (event) => {
        event.stopPropagation();
        onAdd();
    };

    const handleToggle = (event) => {
        event.stopPropagation();
        onToggle();
    };

    return (
        <div className="Comment__header" onClick={onToggle}>
            <h5 className="Comment__title">
                <i className="fa-regular fa-comments"></i>
                Comments
                {count > 0 && <span className="Comment__count">{count}</span>}
            </h5>
            <div className="Comment__header-actions">
                <button type="button" className="Comment__add-button" onClick={handleAdd} title="Add Comment" aria-label="Add Comment">
                    <i className="fa-solid fa-plus"></i>
                </button>
                <button
                    type="button"
                    className="Comment__toggle"
                    onClick={handleToggle}
                    aria-expanded={isOpen}
                    aria-controls={bodyId}
                    title={isOpen ? "Collapse comments" : "Expand comments"}
                    aria-label={isOpen ? "Collapse comments" : "Expand comments"}
                >
                    <i className="fa-solid fa-chevron-up"></i>
                </button>
            </div>
        </div>
    );
}
